export default {
  "content": "<defs><path id=\"a\" d=\"M12 39c2-15.317 11.05-18.948 11-27 0-6.075-4.925-11-11-11S1 5.925 1 12c.167 7.826 9.606 11.802 11 27z\"/><mask id=\"b\" height=\"40\" width=\"24\" x=\"-1\" y=\"-1\"><path d=\"M0 0h24v40H0z\" fill=\"#fff\"/><use xlink:href=\"#a\"/></mask></defs><g fill=\"none\" fill-rule=\"evenodd\"><use fill=\"#E9EAF2\" xlink:href=\"#a\"/><use mask=\"url(#b)\" stroke=\"#999FAC\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" xlink:href=\"#a\"/><circle cx=\"12\" cy=\"12\" fill=\"#999FAC\" r=\"4\"/></g>",
  "attrs": {
    "height": "40",
    "viewBox": "0 0 24 40",
    "width": "24",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink"
  }
};